import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';
import { Patron } from '../models/';

@Injectable()
export class PatronesService extends RESTService<any> {

  public patron: Patron;

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/resumenPaciente',
    });
  }

  // NUEVOS METODOS
  obtenerListadoValoracionesPaciente(tipoPatron: number, numExpediente: string, abierto: boolean): any {
    return this._http.post(environment.api_host + 'patrones/obtenerListadoValoracionesPaciente', {
      iTipoPatron: tipoPatron,
      iNumExp: numExpediente,
      abiertos: abierto,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  // obtenerListadoValoraciones(numExpediente: string, tipoPatron: number): any {
  obtenerListadoValoraciones(tipoPatron: number): any {
    return this._http.post(environment.api_host + 'patrones/obtenerListadoValoraciones', {
      iTipoPatron: tipoPatron,
      // iNumExp: numExpediente,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerPreguntasRespuestasPatronValorado(iIdValoracion: string, numExpediente: string): any {
    return this._http.post(environment.api_host + 'patrones/obtenerPreguntasRespuestasPatronValorado', {
      iIdValoracion: iIdValoracion,
      iNumExpediente: numExpediente,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerPreguntasRespuestasPatron(idPatron: string, sexoPaciente: string, edadDesde: string, edadHasta: string, tipoEdad: string): any {
    return this._http.post(environment.api_host + 'patrones/obtenerPreguntasRespuestasPatron', {
      iIDPatron: idPatron,
      iSexo: sexoPaciente,
      iEdadDesde: edadDesde,
      iEdadHasta: edadHasta,
      iTipoEdad: tipoEdad,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerDiagnosticos(iNumExpediente: string): any {
    return this._http.post(environment.api_host + 'patrones/obtenerDiagnosticos', {
      iNumExpediente: iNumExpediente,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerPreguntasExcluyentes(): any {
    return this._http.post(environment.api_host + 'patrones/obtenerPreguntasExcluyentes', {
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerPreguntasExcluyentesPatron(idPatron: string): any {
    return this._http.post(environment.api_host + 'patrones/obtenerPreguntasExcluyentesPatron', {
      iIdPatron: idPatron,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  HCI_OnCloud_InsertarDatosParaPatronCumplimentado (datos: any): any {
    return this.http.post (environment.api_host + 'patrones/HCI_OnCloud_InsertarDatosParaPatronCumplimentado' , {
      iDatos: datos,
    }).map ((res: Response) => res.json())
      .catch((error: any) => Observable.throw (error.json().error || 'Service error'));
  }

  HCI_OnCloud_GuardarModificacionDatosParaPatronCumplimentado (datos: any): any {
    return this.http.post(environment.api_host + 'patrones/HCI_OnCloud_GuardarModificacionDatosParaPatronCumplimentado' , {
      iDatos: datos,
    }).map ((res: Response) => res.json())
      .catch((error: any) => Observable.throw (error.json().error || 'Service error'));
  }

  BorrarPatronPaciente (iNumExpediente: string, idRespuestas: string): any {
    return this.http.post (environment.api_host + 'patrones/BorrarPatronPaciente' , {
      iNumExpediente: iNumExpediente,
      idRespuestas: idRespuestas,

    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }
  // TODO: LA MAYORIA DE ESTOS METODOS SOLO SE DIFERENCIAN POR EL TIPO DE PATRON A SOLICITAR
  //       POR ELLO SE PODRIAN UNIFICAR EN UNO. SE MANTIENEN ASI POR SI TIENEN UNA LOGICA
  //       EN EL BACKEND DIFERENTE
  obtenerPatronesFuncionalesTodos(pacienteId: string): any {
    return this._http.post(environment.api_host + 'patrones/obtenerPatronesFuncionalesTodos', {
      numeroExpediente: pacienteId,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerProgramasFuncionalesTodos(pacienteId: string): any {
    return this._http.post(environment.api_host + 'patrones/obtenerProgramasFuncionalesTodos', {
      numeroExpediente: pacienteId,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerTestsTodos(pacienteId: string): any {
    return this._http.post(environment.api_host + 'patrones/obtenerTestsTodos', {
      numeroExpediente: pacienteId,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  // TODO: SE PUEDEN AGRUPAR ESTOS TRES METODOS  EN UNO SOLO
  obtenerPatronesFuncionalesAbiertos(pacienteId: string): any {
    return this._http.post(environment.api_host + 'patrones/obtenerPatronesFuncionalesAbiertos', {
      numeroExpediente: pacienteId,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerProgramasFuncionalesAbiertos(pacienteId: string): any {
    return this._http.post(environment.api_host + 'patrones/obtenerProgramasFuncionalesAbiertos', {
      numeroExpediente: pacienteId,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerTestAbiertos(pacienteId: string): any {
    return this._http.post(environment.api_host + 'patrones/obtenerTestAbiertos', {
      numeroExpediente: pacienteId,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }
  // FIN DEL BLOQUE CON POSIBILIDAD DE SER AGRUPADOS

  obtenerPatronesCerrados(pacienteId: string): any {
    return this._http.post(environment.api_host + 'patrones/obtenerPatronesCerrados', {
      numeroExpediente: pacienteId,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  // TODO: SE PUEDEN AGRUPAR ESTOS TRES METODOS  EN UNO SOLO
  obtenerPatronFuncionalPorId(patronId: string): any {
    return this._http.post(environment.api_host + 'patrones/obtenerPatronFuncionalPorId', {
      idPatron: patronId,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerProgramaFuncionalPorId(patronId: string): any {
    return this._http.post(environment.api_host + 'patrones/obtenerProgramaFuncionalPorId', {
      idPatron: patronId,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  obtenerTestPorId(patronId: string): any {
    return this._http.post(environment.api_host + 'patrones/obtenerTestPorId', {
      idPatron: patronId,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }
  // FIN DEL BLOQUE CON POSIBILIDAD DE SER AGRUPADOS

  guardarTest(params: any): Observable<string> {
    return this._http.post(environment.api_host + 'patrones/guardarTest', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.resultado !== undefined) {
        return respuesta.resultado;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }

  guardarPatron(params: any): Observable<string> {
    return this._http.post(environment.api_host + 'patrones/guardarPatron', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.resultado !== undefined) {
        return respuesta.resultado;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }

  guardarPrograma(params: any): Observable<string> {
    return this._http.post(environment.api_host + 'patrones/guardarPrograma', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.resultado !== undefined) {
        return respuesta.resultado;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }

}



// WEBPACK FOOTER //
// ./src/services/patrones.service.ts